import React from "react";
import styles from "./DecorativeLine.module.css";

const DecorativeLine = () => {
  return <div className={styles.decorativeElement}></div>;
};

export default DecorativeLine;
